import { render } from "./BillingList.vue?vue&type=template&id=ca5897ee&scoped=true"
import script from "./BillingList.vue?vue&type=script&lang=js"
export * from "./BillingList.vue?vue&type=script&lang=js"

import "./BillingList.vue?vue&type=style&index=0&id=ca5897ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca5897ee"]])

export default __exports__